module.exports = "pegasus/assets/blocks/header-8-theme2.png";